<template>
  <div>
    <ul
      class="inl-100 max-w-md space-y-1 text-gray-500 list-disc list-inside dark:text-gray-400 text-left"
    >
      <li
        :style="{
          width: contentLeftBlock + 'px',
        }"
        class="flex flex-row items-center"
        v-for="(el, ind) in contentFiles"
        :key="ind"
      >
        <a :href="el.file">{{ el.name }}.{{ el.ext }}</a>
        <div
            @click="() => {
                deleteFile(ind, el.uuid,);
            }"
            class="ml-2 pointer"
            v-if="canEdit">
            <img 
                style="width: 15px; height: 15px;"
                src="/assets/images/icons/trash-can.png" 
                alt="">
        </div>
      </li>
    </ul>

    <div
        v-if="canEdit"
        class="flex justfiy-start flex-col text-left margin-t-15">
      <div class="f-18 font-bold">Загрузить файл</div>
      <div class="flex flex-row">
        <FileField 
            style="margin-right: 15px"
            cls="mt-2"
            v-model="file" 
        />
        <div>
          <button
            v-if="file"
            @click="saveData"
            class="bg-emerald-500 text-white active:bg-emerald-600 font-bold uppercase text-xs px-4 py-2 rounded shadow hover:shadow-md outline-none focus:outline-none ease-linear transition-all duration-150"
            type="button"
          >
            Загрзить
          </button>
        </div>
      </div>
    </div>
    
  </div>
</template>

<script>

import { mapActions } from 'vuex';
import FileField from "@/components/Forms/FileField.vue";
import { API_CLIENT, HEADERS_TOKEN_JSON_FILE } from "@/const/uri";
import axios from "axios";

export default {
  components: {
    FileField,
  },
  data() {
    return {
      file: null,
    };
  },
  mounted() {},
  methods: {
    ...mapActions(["toggleAlert"]),
    async saveData() {
      await axios({
        method: "POST",
        url: API_CLIENT.tsorDetail + this.$route.params.themeUUID + "/files/",
        headers: HEADERS_TOKEN_JSON_FILE(),
        data: {
            file: this.file,
        },
      })
        .then((e) => {
          console.log(e);
          this.toggleAlert({
            message: "Файл успешно загружен",
            isError: false,
          });
          this.$parent.updateTsorFile(e.data.data);
        })
        .catch(function (e) {
          console.log(e);
        });
    },
    async deleteFile(ind, uuid,) {
      await axios({
        method: "DELETE",
        url: API_CLIENT.tsorDetail + uuid + "/delete_file/",
        headers: HEADERS_TOKEN_JSON_FILE(),
        data: {
            file: this.file,
        },
      })
        .then(() => {
            this.toggleAlert({
                message: "Файл успешно Удален",
                isError: true,
            });
            this.$parent.delteTsorFile(ind);
        })
        .catch(function (e) {
          console.log(e);
        });
    },
  },
  props: {
    canEdit: {
      default: false,
    },
    contentFiles: {},
    contentLeftBlock: {},
    themeUUID: {
      default: null,
    },
  },
};
</script>